import 'antd/dist/antd';
import { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import App from './App';
import './styles.css';
import { Provider } from 'react-redux';
import store from './store/store';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './Context/AuthProvider';
import { ProSidebarProvider } from 'react-pro-sidebar';
const root = ReactDOM.createRoot(document.getElementById('root'));
//Files from new source
root.render(
  <Suspense fallback={null}>
    <ProSidebarProvider>
      <BrowserRouter>
        {/* <AuthProvider> */}
        <Provider store={store}>
          <App />
        </Provider>
        {/* </AuthProvider> */}
      </BrowserRouter>
    </ProSidebarProvider>
  </Suspense>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
